import './style.css';

import { TextField } from '@material-ui/core';
import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import LoadingPanel from '../../layout/loading-panel';

class QuickSearch extends React.Component {
  //THIS IS NOW VERSION 3 OF AUTO SUGGEST AS THE OTHER 2 HAVE BECOME VERY BLOATED
  //DO NOT MODIFY THIS AS IT IS BEING KEPT DELIBERATELY SIMPLE FOR DRAFT INTEGRATION
  //IF YOU NEED TO MAKE CHANGES PLEASE DISCUSS THESE FIRST
  constructor(props) {
    super(props);

    this.token = null;
    this.onDebounce = _.debounce(this.onSearch, 1000);

    this.inputRef = (element) => {
      this.input = element;
    };
    this.quickSearchRef = (element) => {
      this.quickSearch = element;
    };

    this.focus = this.focus.bind(this);
    this.scrollIntoView = this.scrollIntoView.bind(this);

    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onRequestClose = this.onRequestClose.bind(this);

    this.state = {
      term: '',
      index: 0,
      items: [],
      loading: false
    };
  }

  focus() {
    const { input } = this;
    if (!input) {
      return;
    }

    input.focus();
  }

  scrollIntoView(override) {
    const { quickSearch } = this;
    if (!quickSearch) {
      return;
    }

    const options = override != null ? override : QuickSearch.scrollIntoViewOptions;
    quickSearch.scrollIntoView(options);
  }

  componentDidMount() {
    if (this.props.open) {
      this.focus();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.focus();
    }
  }

  render() {
    if (!this.props.open) {
      return null;
    }

    let { term, items, index, loading, placeholder } = this.state;

    let results = <div>No Records Found</div>;
    if (items.length > 0) {
      results = items.map((x, i) => {
        return (
          <div
            key={i}
            className={cx({ selected: i === index, 'menu-item': true })}
            onClick={this.onSelect.bind(this, x)}
          >
            {x.name}
          </div>
        );
      });
    }

    let style = { minHeight: loading ? 100 : 0, minWidth: 200 };

    let content =
      term.trim() !== '' ? (
        <LoadingPanel size={1} loading={loading} style={style}>
          {results}
        </LoadingPanel>
      ) : null;

    return (
      <div ref={this.quickSearchRef} className="quick-search">
        <div className="quick-search-header">
          <div className="title">{this.props.title || ''}</div>
          <div className="close-icon" onClick={this.onRequestClose}>
            &times;
          </div>
        </div>
        <div className="quick-search-body">
          <TextField
            inputRef={this.inputRef}
            value={term}
            fullWidth={true}
            multiLine={false}
            placeholder={placeholder || 'Search'}
            onChange={this.onChange}
            onKeyDown={this.onKeyDown}
          />
          <div className="quick-search-results">{content}</div>
        </div>
      </div>
    );
  }

  onChange(e) {
    let term = e.target.value;
    this.setState({ term: term, loading: true });
    this.onDebounce(term);
  }

  onSearch(term) {
    let { src, onAction } = this.props;

    if (!!this.token && !!this.token.cancel) {
      this.token.cancel();
    }

    this.token = {};

    onAction('search', { key: src, term: term, token: this.token }).then((res) => {
      this.setState({ items: res, loading: false });
    });
  }

  onRequestClose() {
    this.setState({ index: 0, term: '' });
    this.props.onRequestClose();
  }

  onKeyDown(e) {
    let { items, index } = this.state;
    let state = {};

    switch (e.keyCode || e.which) {
      case 27:
        this.onRequestClose();
        break;
      case 38:
        state = { index: Math.max(0, index - 1) };
        break;
      case 40:
        // Clamp to the last real item. Previously this allowed index === items.length,
        // leaving items[index] undefined and crashing the parent onSelect (item.value).
        state = { index: Math.max(0, Math.min(items.length - 1, index + 1)) };
        break;
      case 13: {
        const selected = items[index];
        // Guard against an out-of-range/empty selection: firing onSelect(undefined) throws
        // in the parent (Cannot read properties of undefined reading 'value'), which crashes
        // the React subtree and corrupts the surrounding layout.
        if (selected !== undefined) {
          this.onSelect(selected);
        }
        break;
      }
      default:
        return;
    }

    e.preventDefault();
    e.stopPropagation();

    this.setState(state);
  }

  onSelect(item) {
    this.setState({ index: 0, term: '' });
    this.props.onSelect(item);
  }
}

QuickSearch.defaultProps = {
  open: true,
  src: '',
  onSelect: () => {},
  onAction: () => {
    Promise.resolve([]);
  },
  onRequestClose: () => {}
};

QuickSearch.scrollIntoViewOptions = {
  behavior: 'smooth',
  block: 'start',
  inline: 'start'
};

export default QuickSearch;

export const { defaultProps } = QuickSearch;
